<ng-template #panelTemplate>
    <div
        class="{{ panelClass }} lg-panel__body-holder"
        [hidden]="_context.minimized"
        [lgLoaderOverlay]="!!(_showLoaderOverlay$ | async) && !_context.minimized"
        [lgLoaderOverlayDelay]="loaderOverlayDelay"
        [lgLoaderOverlaySkip]="loaderOverlaySkip"
    >
        @if (!_context.minimized) {
            @if (!_panelBody) {
                <div class="lg-panel__body" lgDetachmentNotifier>
                    <ng-content></ng-content>
                </div>
            } @else {
                <div class="lg-panel__body">
                    <ng-container
                        *ngTemplateOutlet="_panelBody!._bodyTemplate ?? null; context: _context"
                    ></ng-container>
                </div>
            }
            <ng-template #panelBodyBlock>
                <div class="lg-panel__body">
                    <ng-container
                        *ngTemplateOutlet="_panelBody!._bodyTemplate ?? null; context: _context"
                    ></ng-container>
                </div>
            </ng-template>
        }
    </div>
</ng-template>
